export default [
  { pathname: '/material-ui/api/accordion' },
  { pathname: '/material-ui/api/accordion-actions' },
  { pathname: '/material-ui/api/accordion-details' },
  { pathname: '/material-ui/api/accordion-summary' },
  { pathname: '/material-ui/api/alert' },
  { pathname: '/material-ui/api/alert-title' },
  { pathname: '/material-ui/api/app-bar' },
  { pathname: '/material-ui/api/autocomplete' },
  { pathname: '/material-ui/api/avatar' },
  { pathname: '/material-ui/api/avatar-group' },
  { pathname: '/material-ui/api/backdrop' },
  { pathname: '/material-ui/api/badge' },
  { pathname: '/material-ui/api/bottom-navigation' },
  { pathname: '/material-ui/api/bottom-navigation-action' },
  { pathname: '/material-ui/api/box' },
  { pathname: '/material-ui/api/breadcrumbs' },
  { pathname: '/material-ui/api/button' },
  { pathname: '/material-ui/api/button-base' },
  { pathname: '/material-ui/api/button-group' },
  { pathname: '/material-ui/api/card' },
  { pathname: '/material-ui/api/card-action-area' },
  { pathname: '/material-ui/api/card-actions' },
  { pathname: '/material-ui/api/card-content' },
  { pathname: '/material-ui/api/card-header' },
  { pathname: '/material-ui/api/card-media' },
  { pathname: '/material-ui/api/checkbox' },
  { pathname: '/material-ui/api/chip' },
  { pathname: '/material-ui/api/circular-progress' },
  { pathname: '/material-ui/api/click-away-listener' },
  { pathname: '/material-ui/api/collapse' },
  { pathname: '/material-ui/api/container' },
  { pathname: '/material-ui/api/css-baseline' },
  { pathname: '/material-ui/api/dialog' },
  { pathname: '/material-ui/api/dialog-actions' },
  { pathname: '/material-ui/api/dialog-content' },
  { pathname: '/material-ui/api/dialog-content-text' },
  { pathname: '/material-ui/api/dialog-title' },
  { pathname: '/material-ui/api/divider' },
  { pathname: '/material-ui/api/drawer' },
  { pathname: '/material-ui/api/fab' },
  { pathname: '/material-ui/api/fade' },
  { pathname: '/material-ui/api/filled-input' },
  { pathname: '/material-ui/api/form-control' },
  { pathname: '/material-ui/api/form-control-label' },
  { pathname: '/material-ui/api/form-group' },
  { pathname: '/material-ui/api/form-helper-text' },
  { pathname: '/material-ui/api/form-label' },
  { pathname: '/material-ui/api/global-styles' },
  { pathname: '/material-ui/api/grid' },
  { pathname: '/material-ui/api/grow' },
  { pathname: '/material-ui/api/icon' },
  { pathname: '/material-ui/api/icon-button' },
  { pathname: '/material-ui/api/image-list' },
  { pathname: '/material-ui/api/image-list-item' },
  { pathname: '/material-ui/api/image-list-item-bar' },
  { pathname: '/material-ui/api/init-color-scheme-script' },
  { pathname: '/material-ui/api/input' },
  { pathname: '/material-ui/api/input-adornment' },
  { pathname: '/material-ui/api/input-base' },
  { pathname: '/material-ui/api/input-label' },
  { pathname: '/material-ui/api/linear-progress' },
  { pathname: '/material-ui/api/link' },
  { pathname: '/material-ui/api/list' },
  { pathname: '/material-ui/api/list-item' },
  { pathname: '/material-ui/api/list-item-avatar' },
  { pathname: '/material-ui/api/list-item-button' },
  { pathname: '/material-ui/api/list-item-icon' },
  { pathname: '/material-ui/api/list-item-secondary-action' },
  { pathname: '/material-ui/api/list-item-text' },
  { pathname: '/material-ui/api/list-subheader' },
  { pathname: '/material-ui/api/masonry' },
  { pathname: '/material-ui/api/menu' },
  { pathname: '/material-ui/api/menu-item' },
  { pathname: '/material-ui/api/menu-list' },
  { pathname: '/material-ui/api/mobile-stepper' },
  { pathname: '/material-ui/api/modal' },
  { pathname: '/material-ui/api/native-select' },
  { pathname: '/material-ui/api/no-ssr' },
  { pathname: '/material-ui/api/outlined-input' },
  { pathname: '/material-ui/api/pagination' },
  { pathname: '/material-ui/api/pagination-item' },
  { pathname: '/material-ui/api/paper' },
  { pathname: '/material-ui/api/pigment-container' },
  { pathname: '/material-ui/api/pigment-grid' },
  { pathname: '/material-ui/api/pigment-stack' },
  { pathname: '/material-ui/api/popover' },
  { pathname: '/material-ui/api/popper' },
  { pathname: '/material-ui/api/portal' },
  { pathname: '/material-ui/api/radio' },
  { pathname: '/material-ui/api/radio-group' },
  { pathname: '/material-ui/api/rating' },
  { pathname: '/material-ui/api/scoped-css-baseline' },
  { pathname: '/material-ui/api/select' },
  { pathname: '/material-ui/api/skeleton' },
  { pathname: '/material-ui/api/slide' },
  { pathname: '/material-ui/api/slider' },
  { pathname: '/material-ui/api/snackbar' },
  { pathname: '/material-ui/api/snackbar-content' },
  { pathname: '/material-ui/api/speed-dial' },
  { pathname: '/material-ui/api/speed-dial-action' },
  { pathname: '/material-ui/api/speed-dial-icon' },
  { pathname: '/material-ui/api/stack' },
  { pathname: '/material-ui/api/step' },
  { pathname: '/material-ui/api/step-button' },
  { pathname: '/material-ui/api/step-connector' },
  { pathname: '/material-ui/api/step-content' },
  { pathname: '/material-ui/api/step-icon' },
  { pathname: '/material-ui/api/step-label' },
  { pathname: '/material-ui/api/stepper' },
  { pathname: '/material-ui/api/svg-icon' },
  { pathname: '/material-ui/api/swipeable-drawer' },
  { pathname: '/material-ui/api/switch' },
  { pathname: '/material-ui/api/tab' },
  { pathname: '/material-ui/api/tab-context' },
  { pathname: '/material-ui/api/table' },
  { pathname: '/material-ui/api/table-body' },
  { pathname: '/material-ui/api/table-cell' },
  { pathname: '/material-ui/api/table-container' },
  { pathname: '/material-ui/api/table-footer' },
  { pathname: '/material-ui/api/table-head' },
  { pathname: '/material-ui/api/table-pagination' },
  { pathname: '/material-ui/api/table-pagination-actions' },
  { pathname: '/material-ui/api/table-row' },
  { pathname: '/material-ui/api/table-sort-label' },
  { pathname: '/material-ui/api/tab-list' },
  { pathname: '/material-ui/api/tab-panel' },
  { pathname: '/material-ui/api/tabs' },
  { pathname: '/material-ui/api/tab-scroll-button' },
  { pathname: '/material-ui/api/textarea-autosize' },
  { pathname: '/material-ui/api/text-field' },
  { pathname: '/material-ui/api/timeline' },
  { pathname: '/material-ui/api/timeline-connector' },
  { pathname: '/material-ui/api/timeline-content' },
  { pathname: '/material-ui/api/timeline-dot' },
  { pathname: '/material-ui/api/timeline-item' },
  { pathname: '/material-ui/api/timeline-opposite-content' },
  { pathname: '/material-ui/api/timeline-separator' },
  { pathname: '/material-ui/api/toggle-button' },
  { pathname: '/material-ui/api/toggle-button-group' },
  { pathname: '/material-ui/api/toolbar' },
  { pathname: '/material-ui/api/tooltip' },
  { pathname: '/material-ui/api/typography' },
  { pathname: '/material-ui/api/zoom' },
];
